import { getEntryTypeId } from './getEntryTypeId.js';
const isContentEntryOfType = (typeId, entry) => {
  const entryTypeId = getEntryTypeId(entry);
  return Boolean(entryTypeId) && entryTypeId === typeId;
};
export { isContentEntryOfType };
//# sourceMappingURL=isContentEntryOfType.js.map
